import { AttachmentFilterType } from '../../../enums/attachmentFiltertype'

interface GetDefaultAttachmentFilterTypeProps {
  isEInvoicingOnly: boolean
  isEDocumentReadAuthorized: boolean
}

export const getDefaultAttachmentFilterType = ({
  isEInvoicingOnly,
  isEDocumentReadAuthorized,
}: GetDefaultAttachmentFilterTypeProps): AttachmentFilterType => {
  if (isEInvoicingOnly) {
    return AttachmentFilterType.EDocument
  }

  return isEDocumentReadAuthorized ? AttachmentFilterType.All : AttachmentFilterType.Upload
}
